<template>
    <section class="register info-block">   
        <div class="register-title">Моментальная регистрация</div>
        <div
            @click="$store.dispatch('user/setRegister', false)"
            class="register-hide"
        ></div>
        <div class="register-body">
            <form            
                @submit.prevent="register"
                autocomplete="on"
            >
                <div class="form-group">
                    <label
                        for="username"
                        class="label"
                    >Телефон или email:</label>
                    <input
                        v-model="username"
                        type="text"
                        name="username"
                        id="username"
                        v-validate="{required: true, phoneOrMail: true}"
                        autocomplete="username"
                        class="input"
                        :class="{'field-error': errors.has('username')}"
                    >
                    <label
                        for="username"
                        class="v-error label-tip"
                    >{{ errors.first('username') }}</label>
                </div>
                <div class="form-group">
                    <label
                        for="register-password"
                        class="label"
                    >Пароль:</label>
                    <input
                        type="password"
                        v-model="password"
                        name="register-password"
                        id="register-password"
                        ref="password"
                        v-validate="'required|min:6'"
                        autocomplete="new-password"
                        class="input"
                        :class="{'field-error': errors.has('register-password')}"
                    >
                    <label
                        for="register-password"
                        class="v-error label-tip"
                    >{{ errors.first('register-password') }}</label>
                </div>
                <div class="form-group">
                    <label
                        for="password-confirm"
                        class="label"
                    >Повторите пароль:</label>
                    <input
                        v-model="passwordConfirm"
                        type="password"
                        name="password-confirm"
                        id="password-confirm"
                        v-validate="'required|confirmed:password|min:6'"
                        autocomplete="new-password"
                        class="input"
                        :class="{'field-error': errors.has('password-confirm')}"
                    >
                    <label
                        for="password"
                        class="v-error label-tip"
                    >{{ errors.first('password-confirm') }}</label>
                </div>
                <div class="form-tip">
                    Нажимая кнопку Регистрация, вы принимаете
                    <redirectButton
                        pathname="rules"
                        html="Правила"
                        class="link-blue-underlined"
                    ></redirectButton> и
                    <redirectButton
                        pathname="legal"
                        html="Политику использования данных"
                        class="link-blue-underlined"
                    ></redirectButton>.                     
                </div>
                <div class="form-bottom">
                    <button
                        v-if="!loader"
                        type="submit"
                        class="button-blue"
                    >Регистрация</button>
                    <button
                        v-if="loader"
                        class="button-loader"
                    ></button>
                </div>
            </form>
        </div>
    </section>
</template>

<script>
    import {mapGetters} from 'vuex';
    import redirectButton from '@/components/Buttons/Redirect';
    import {localizeValidation} from '@/mixins/localizeValidation';

    export default {
        name: 'Register',
        components: {
            redirectButton
        },
        mixins: [localizeValidation],
        data() {
            return {
                username: '',
                password: '',
                passwordConfirm: '',
                phone: '',
                email: '',
                loader: false,
                nonFieldErrors: []
            }
        },
        computed: {
            ...mapGetters({
                userErrors: 'user/errors',
                isEmpty: 'user/isEmpty',
                registerData: 'user/fetchRegisterData'
            })
        },
        created() {
            this.localizeValidation();

            let self = this;

            const phoneOrMailRule = {
                getMessage(field, isPhoneOrMail, data) {
                    return (data && data.message) || `введите корректный телефон или email`;
                },
                validate(value, isPhoneOrMail) {
                    if (isPhoneOrMail) {
                        if (self.username.indexOf('@') >= 0) {
                            //email
                            const regexMail = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                            self.email = self.username;
                            self.phone = '';
                            return {
                                data: {message: 'введите корректный адрес email'},
                                valid: regexMail.test(self.username)
                            };                            
                        } else if (
                            /^\+/.test(self.username) ||
                            /[0-9]{2,}/.test(self.username)
                        ) {
                            //phone
                            self.phone = self.username.replace(/[^+0-9.]/g, "");
                            const regexPhone = /^\+[0-9]{11,}$/;
                            self.phone = self.username;
                            self.email = '';
                            return {
                                data: {message: 'формат телефона: +XХХХХХХХХХХ (не менее 11 символов)'},
                                valid: regexPhone.test(self.phone)
                            };
                        }
                        return {data: null, valid: false};
                    } else {
                        return {valid: true};
                    }
                    
                }
            }

            this.$validator.extend('phoneOrMail', phoneOrMailRule);
        },
        methods: {
            register() {
                this.$validator.validateAll()
                .then((valid) => {
                    if (valid) {
                        this.loader = true;

                        this.$store.dispatch('user/create', {
                            phone: this.phone,
                            email: this.email,
                            password: this.password
                        })
                        .then(() => {
                            this.$store.dispatch('user/setRegister', false);
                            if (this.registerData.phone) {
                                this.$modal.show(
                                    'confirm-phone',
                                    {
                                        register: true,
                                        phone: this.registerData.phone,
                                        password: this.password
                                    }
                                );
                            } else {
                                this.$modal.show('dialog', {
                                    title: 'Спасибо за регистрацию!',
                                    text: 'Для завершения регистрации перейдите по ссылке, отправленной на указанный e-mail.',
                                    buttons: [
                                        {
                                            title: 'Ок'
                                        }
                                    ]
                                });
                            }
                            this.loader = false;
                        })
                        .catch((err) => {
                            for (let key in this.userErrors) {
                                this.errors.add({
                                    field: key,
                                    msg: this.userErrors[key][0]
                                });       
                            }
                            this.loader = false;
                        });
                    }                    
                });
            }
        }
    }
</script>

<style scoped lang="scss">
    @import '~@/assets/styles/components/_validation';
    @import '~@/assets/styles/layout/_register';
</style>
